import {createToaster, type CreateToasterReturn} from '@chakra-ui/react'

export const toaster: CreateToasterReturn = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
})

const create = toaster.create
toaster.create = props => create({closable: true, ...props})

const success = toaster.success
toaster.success = props => success({closable: true, ...props})

const info = toaster.info
toaster.info = props => info({closable: true, ...props})

const error = toaster.error
toaster.error = props => error({closable: true, ...props})

const warning = toaster.warning
toaster.warning = props => warning({closable: true, ...props})
